<div class="paisa-loader">
    <div class="paisa-loader__wrapper">
        <img src="https://images.5paisa.com/login/loader.gif" width="70" height="70" alt="5paisa Loader" title="5paisa">
    </div>
</div>